import { KeycloakGroup } from "../../../model/CarbonExternalModels";
import { UserPermission } from "../../../model/CarbonPermissionModels";

interface IProps {
    group: KeycloakGroup;
    nameError: string;
    onFieldChange(data): void;
    permissions: UserPermission;
}

export default function UserGroupDetails({ group, onFieldChange, nameError, permissions }: IProps) {
    const canChange = group.editable && permissions.isUserCreator;

    function handleNameChange(event) {
        if (canChange) onFieldChange({ name: event.target.value });
    }
    function handleDescriptionChange(event) {
        if (canChange) onFieldChange({ description: event.target.value });
    }

    return (
        <div className="gcm-form-Body">
            <div className="gcm-form-Header">
                <div className="gcm-form-Row">
                    <h1 className="gcm-form-HeaderTitle">Permission Set Details</h1>
                </div>
                <div className="gcm-form-Row">
                    <h3 className="gcm-form-HeaderDescription">
                        Permission sets allow you to assign a set of permissions to a group of users.
                    </h3>
                </div>
            </div>
            <div className="gcm-form-Contents">
                <div className="gcm-form-Column gcm-form-SmallGap">
                    <h4 className="gcm-form-ContentsTitle">Permission Set Details</h4>
                    <h5 className="gcm-form-ContentsDescription">Details relating to this permission set.</h5>
                </div>
                <div className="gcm-form-Column gcm-form-SmallGap">
                    <div className="gcm-form-FieldTitle">
                        <h5>Name</h5>
                        <h6>{group.name.length}/60</h6>
                    </div>
                    <input
                        className={`userfulInputField  ${canChange ? "" : "disabled"}`}
                        placeholder="Enter name here..."
                        type="text"
                        maxLength={60}
                        value={group.name}
                        onChange={handleNameChange}
                    />
                    {nameError && <div className="errorText">{nameError}</div>}
                </div>
                <div className="gcm-form-Column gcm-form-SmallGap">
                    <div className="gcm-form-FieldTitle">
                        <h5>Description</h5>
                        <h6>{group.description.length}/200</h6>
                    </div>
                    <textarea
                        className={`uTextarea  ${canChange ? "" : "disabled"}`}
                        placeholder="Enter description here..."
                        maxLength={200}
                        value={group.description}
                        onChange={handleDescriptionChange}
                    />
                </div>
            </div>
        </div>
    );
}
